import Tool from '@/assets/js/utils.js'
import HeartbeatWorker from '@/assets/js/worker/heartbeat.worker.js'
class Sockets {
  // 使用es6语法 生成websocket方法
  constructor (data) {
    this.url = data.url || ''
    this.param = data.param || {}
    this.message = data.message || ''
    this.time = data.time || 2000
    this.success = data.success || ''
    this.error = data.error || ''
    this.response = data.response || ''
    this.key = data.key || ''
    // 内部变量
    this.closed = null
    this.interval = null
    this.responseObj = null
    this.successObj = null
    this.rInfo = null
    this.sendMsgs = null
    this.socket = null
    this.sendHeart = data.sendHeart || false
    this.receMsg = null
    this.sendHeartInterval = null
    this.heartWorker = null
  }

  destroyHeartWorker () {
    // 停止并销毁心跳 Worker，防止 reconnect（off→init）路径叠加泄漏
    if (this.heartWorker) {
      try {
        this.heartWorker.postMessage({ type: 'stop' })
        this.heartWorker.terminate()
      } catch (error) {
        console.log(error)
      }
      this.heartWorker = null
    }
  }

  startHeartFallback (beat) {
    // Worker 不可用时退回主线程定时器（后台会被节流，但好过无心跳）
    if (this.sendHeartInterval) clearInterval(this.sendHeartInterval)
    this.sendHeartInterval = setInterval(beat, 5000)
  }

  init () {
    /*
     * var protocol = document.location.protocol === 'https:' ? 'wss://' : 'ws://'
     * var pathname = document.location.pathname.slice(document.location.pathname.indexOf('/'), document.location.pathname.indexOf('/', document.location.pathname.indexOf('/') + 1) + 1)
     */
    var urlParam = ''
    var that = this
    that.closed = false
    that.interval = {}
    that.responseObj = {}
    that.successObj = {}
    that.sendMsgs = {}
    that.rInfo = {}
    /*
     * console.log('init', true)
     * 拼接websocket地址
     */
    for (var k in that.param) {
      urlParam += k + '=' + that.param[k] + '&'
    }
    urlParam = urlParam.slice(0, urlParam.length - 1)
    if (urlParam) urlParam = '?' + urlParam
    if (!that.url) {
      console.log('请输入接口地址')
      return
    }
    // var socketUrl = protocol + document.location.host + pathname + that.url + urlParam;
    var socketUrl = that.url + urlParam
    try {
      that.socket = new WebSocket(socketUrl)
    } catch (error) {
      console.log(error)
    }
    // 绑定事件
    that.socket.onopen = function () {
      that.send({
        message: that.message,
        time: that.time,
        key: that.key,
        resonse: that.response,
        success: that.success
      })

      if (that.sendHeartInterval) clearInterval(that.sendHeartInterval)
      that.destroyHeartWorker()
      // 用来判断是否发心跳；心跳时钟放在 Worker 里，避免后台标签页定时器节流导致
      // 心跳间隔超过网关空闲超时被 1006 掐断（主线程 setInterval 仅作降级兜底）
      if (that.sendHeart) {
        var beat = function () {
          if (that.socket && that.socket.readyState === 1) {
            that.socket.send(1)
          }
        }
        try {
          that.heartWorker = new HeartbeatWorker()
          that.heartWorker.onmessage = beat
          that.heartWorker.onerror = function () {
            that.destroyHeartWorker()
            that.startHeartFallback(beat)
          }
          that.heartWorker.postMessage({ type: 'start', interval: 5000 })
        } catch (error) {
          console.log(error)
          that.heartWorker = null
          that.startHeartFallback(beat)
        }
      }
    }
    that.socket.onmessage = function (e) {
      Object.keys(that.responseObj).forEach(function (key) {
        var response = that.responseObj[key]
        response(e)
      })
      if (e.data !== 'heartbeat' && e.data && e.data.length > 1) {
        if (!Tool.isJSON(e.data)) {
          console.log('数据格式不正确', e.data)
          return
        }
        var data = JSON.parse(e.data)
        var key
        if (data.categoryId && data.operationType) {
          var rkey = 'key' + data.categoryId + data.operationType
          const isRPS = window.location.href.includes('/#/rps')
          if (isRPS && data.rid) rkey = rkey + data.rid
          Object.keys(that.rInfo).forEach(function (v) {
            if (that.rInfo[v] === rkey) {
              key = v
            }
          })
        } else if (data.dataType) {
          key = data.dataType
        }
        key = key || JSON.parse(e.data).module // 获取后台返回的key 以便响应对应的response 注意这个key要和后台返回的关键字相同
        var success = that.successObj[key]
        if (key == 'configTDataResult') {
          success = that.successObj.configTData
        }
        try {
          if (typeof that.receMsg == 'function') that.receMsg(e.data)
          if (success) success(JSON.parse(e.data))
        } catch (error) {
        }
      } else {
        success = that.successObj.heart
        if (success) success(e)
      }
      if (that.key == 'RPSWebsocket') {
        that.success(e)
      }
    }
    that.socket.onerror = function (e) {
      if (typeof that.error === 'function') that.error(e)
    }
    that.socket.onclose = function (e) {
      if (!that.closed) {
        setTimeout(() => {
          that.reconnect(e)
        }, 3000)
      }
    }
  }

  reconnect (e) {
    // websocket断线重连，只要非前端主动断开的连接，都会重连
    var that = this
    var sendMsgs = this.sendMsgs
    that.off()
    if (e.code === 3001 || e.code === 3000 || !sendMsgs) return // 3001代表session过期，不用重连了.
    that.init()
    if (!sendMsgs) return
    Object.keys(sendMsgs).forEach(function (v) {
      that.send(sendMsgs[v])
    })
    console.log('reconnect')
  }

  send (data) {
    // websocket发送信息 isMoreSend是否是多次发同一key canSendMore:是否允许多值发送
    var that = this
    var message = data.message || ''
    var time = data.time || 1000
    var key = data.key || ''
    var response = data.response || ''
    var success = data.success || ''
    var heart = data.isHeart || false
    if (data.receMsg) {
      that.receMsg = data.receMsg
    }

    if (!heart) {
      if (!message || !key || !that.interval) return
      if (!data.isOnce) {
        if (Object.keys(that.interval).indexOf(key) > -1) {
          // 当前websocket连接中，key值唯一
          // console.log("当前key值已存在！");
          console.log(key, 'Current key  exist!')
          return
        }
      }
      // 构造信息，信息类型必须为字符串，带有module值
      var msg = typeof message === 'string' ? JSON.parse(message) : message
      if (msg.categoryId && msg.operationType) {
        var rkey = 'key' + msg.categoryId + msg.operationType
        const isRPS = window.location.href.includes('/#/rps')
        if (isRPS && msg.rid) rkey = rkey + msg.rid
        that.rInfo[key] = rkey
      } else if (msg.dataType) {
        key = msg.dataType
      } else {
        if (!msg.module) msg.module = key
      }
      msg = JSON.stringify(msg)
      that.sendMsgs[key] = data
      // 发送信息
      var isOnce = data.isOnce || ''
      if (isOnce) {
        that.interval[key] = setInterval(() => {
          if (that.socket && that.sendMsgs[key] && that.socket.readyState === 1) {
            that.interval[key] && clearInterval(that.interval[key])
            that.socket.send(JSON.stringify(that.sendMsgs[key].message))
          }
        }, time)
      } else {
        that.interval[key] = setInterval(() => {
          if (that.socket && that.sendMsgs[key] && that.socket.readyState === 1) { that.socket.send(JSON.stringify(that.sendMsgs[key].message)) }
        }, time)
      }
      // 将相关值储存在当前对象中
      if (typeof response === 'function') that.responseObj[key] = response
      if (typeof success === 'function') that.successObj[key] = success
    } else {
      that.interval[key] = setInterval(function () {
        if (that.socket && that.socket.readyState === 1) { that.socket.send(message) }
      }, time)
      if (typeof response === 'function') that.responseObj[key] = response
      if (typeof success === 'function') that.successObj[key] = success
    }
  }

  has (key) {
    // 查找当前连接中是否有所传key的信息
    return this.interval && Object.keys(this.interval).indexOf(key) > -1
  }

  stop (key) {
    // 从当前连接中，删除指定的信息传递
    var that = this
    if (Object.prototype.toString.call(key) === '[object Array]') {
      key.forEach(function (key) {
        that.stop(key)
      })
    } else if (typeof key === 'string') {
      if (that.interval) {
        if (Object.keys(that.interval).indexOf(key) > -1) {
          clearInterval(that.interval[key])
          delete that.interval[key]
          delete that.responseObj[key]
          delete that.successObj[key]
          delete that.sendMsgs[key]
          if (that.rInfo[key]) delete that.rInfo[key]
        }
      }
    } else {
      console.log('数据格式错误')
    }
  }

  off () {
    // 关闭连接，重置数据，清除所有定时器
    var that = this
    that.closed = true
    that.destroyHeartWorker()
    if (that.sendHeartInterval) {
      clearInterval(that.sendHeartInterval)
      that.sendHeartInterval = null
    }
    if (that.interval) {
      Object.keys(that.interval).forEach(function (k) {
        clearInterval(that.interval[k])
      })
      that.interval = null
      that.responseObj = null
      that.successObj = null
      that.rInfo = null
      that.sendMsgs = null
    }
    if (that.socket) {
      that.socket.close()
      console.log('close websocket')
      that.socket = null
    }
  }
}

export default Sockets
